/**
 * @license
 */
import { Action } from '@ngrx/store';

// Model
import { UIMasthead } from '@api/models';

// Actions
export const SET_HUBNAME = '[UI Header Masthead] Set hub name';
export const SET_LOGO = '[UI Header Masthead] Set logo';
export const SET_COMBINATION_MARK = '[UI Header Masthead] Set combination mark';

/**
 *
 */
export class SetHubNameAction implements Action {
  readonly type = SET_HUBNAME;
  constructor(public payload: UIMasthead) {}
}

/**
 *
 */
export class SetLogoAction implements Action {
  readonly type = SET_LOGO;
}

/**
 *
 */
export class SetCombinationMarkAction implements Action {
  readonly type = SET_COMBINATION_MARK;
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/store/actions/ui-header/ui-masthead.actions.ts